module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "newBookingDialog"
    }
  }, [_c('h3', {
    staticClass: "wizardTitlxe"
  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.addBooking.title')))]), _vm._v(" "), _c('el-form', {
    ref: "newBookingForm",
    attrs: {
      "model": _vm.newBookingForm,
      "rules": _vm.newBookingRules,
      "label-position": "top"
    }
  }, [(_vm.newBookingForm.order_number) ? _c('div', {
    on: {
      "click": _vm.closeModal
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'orders.edit',
        params: {
          id: _vm.newBookingForm.order_id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.addBooking.showOrder')) + " (#" + _vm._s(_vm.newBookingForm.order_number) + ")")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "background-color": "#eee",
      "padding": "15px",
      "margin-bottom": "10px"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px",
      "margin-bottom": "10px",
      "margin-top": "0"
    }
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.newBookingForm.date)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.newBookingForm.start_time) + " — " + _vm._s(_vm.newBookingForm.end_time))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "prop": "product_id",
      "label": _vm.$t('static.members.index.dialog.addBooking.selectProduct'),
      "show-message": false
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-top": "-5px",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.$t('static.members.index.dialog.addBooking.selectProduct')
    },
    on: {
      "change": function($event) {
        _vm.newBookingForm.member_id = '';
        _vm.updateEndTime();
      }
    },
    model: {
      value: (_vm.newBookingForm.product_id),
      callback: function($$v) {
        _vm.$set(_vm.newBookingForm, "product_id", $$v)
      },
      expression: "newBookingForm.product_id"
    }
  }, _vm._l((_vm.memberProducts), function(memberProduct) {
    return _c('el-option', {
      key: memberProduct.id,
      attrs: {
        "label": memberProduct.product.name,
        "value": memberProduct.product.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "label": _vm.$t('static.members.index.dialog.addBooking.selectPractitioner'),
      "prop": "member_id",
      "show-message": false
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-top": "-5px",
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.productMembers.length == 0,
      "filterable": "",
      "placeholder": _vm.$t('static.members.index.dialog.addBooking.selectPractitioner')
    },
    model: {
      value: (_vm.newBookingForm.member_id),
      callback: function($$v) {
        _vm.$set(_vm.newBookingForm, "member_id", $$v)
      },
      expression: "newBookingForm.member_id"
    }
  }, _vm._l((_vm.productMembers), function(member) {
    return _c('el-option', {
      key: member.id,
      attrs: {
        "label": member.user.full_name,
        "value": member.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "label": _vm.$t('static.members.index.dialog.addBooking.selectClient'),
      "prop": "client_id",
      "show-message": false
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-top": "-5px",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.$t('static.members.index.dialog.addBooking.selectClient')
    },
    model: {
      value: (_vm.newBookingForm.client_id),
      callback: function($$v) {
        _vm.$set(_vm.newBookingForm, "client_id", $$v)
      },
      expression: "newBookingForm.client_id"
    }
  }, _vm._l((_vm.clients), function(client) {
    return _c('el-option', {
      key: client.id,
      attrs: {
        "label": client.name,
        "value": client.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "small",
    staticStyle: {
      "border": "solid 1px #1bbc9b",
      "color": "#1bbc9b",
      "background-color": "#fff",
      "float": "left"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.store
    }
  }, [(_vm.action == 'EDIT') ? _c('span', [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.update')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.add')))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e963fb8","hasScoped":false}!./src/app/pages/withNavigation/booking/create/create.html
// module id = 2913
// module chunks = 1